import { ricosBICallbacks } from './ricosBICallbacks';
export function biStrategy(appDefId, metaSiteId, wixRicosVersion, ricosVersion, biSettings, _experiments // eslint-disable-line
) {
    const { biCallbacks, postId: settingsPostId, contentId: settingsContentId, ...rest } = biSettings;
    const logger = ricosBICallbacks({
        ...rest,
        postId: settingsPostId || settingsContentId || '',
        appDefId,
        metaSiteId,
        wixRicosVersion,
        ricosVersion,
    });
    return {
        helpers: {
            onModalAction: args => {
                logger.onModalAction(args);
                biCallbacks?.onModalAction?.(args);
            },
            onPluginAdd: (pluginId, entryPoint, version, contentId) => {
                logger.onPluginAdd(pluginId, entryPoint, version, contentId);
                biCallbacks?.onPluginAdd?.(pluginId, entryPoint, version, contentId);
            },
            onPluginAddStep: args => {
                logger.onPluginAddStep(args);
                biCallbacks?.onPluginAddStep?.(args);
            },
            onPluginAddSuccess: (pluginId, entryPoint, params, version, contentId) => {
                logger.onPluginAddSuccess(pluginId, entryPoint, params, version, contentId);
                biCallbacks?.onPluginAddSuccess?.(pluginId, entryPoint, params, version, contentId);
            },
            onPluginDelete: args => {
                logger.onPluginDelete(args);
                biCallbacks?.onPluginDelete?.(args);
            },
            onPublish: (postId, pluginsCount, pluginsDetails, version, contentId) => {
                const appliedContentId = postId || settingsPostId || settingsContentId;
                logger.onPublish(appliedContentId, pluginsCount, pluginsDetails, version, contentId);
                biCallbacks?.onPublish?.(appliedContentId, pluginsCount, pluginsDetails, version, contentId);
            },
            onMenuLoad: args => {
                logger.onMenuLoad(args);
                biCallbacks?.onMenuLoad?.(args);
            },
            onPluginModalOpened: args => {
                logger.onPluginModalOpened(args);
                biCallbacks?.onPluginModalOpened?.(args);
            },
            onViewerAction: (pluginId, actionName, value, contentId, partialNode) => {
                logger.onViewerAction(pluginId, actionName, value, contentId, partialNode);
                biCallbacks?.onViewerAction?.(pluginId, actionName, value, contentId, partialNode);
            },
            onViewerLoaded: args => {
                logger.onViewerLoaded(args);
                biCallbacks?.onViewerLoaded?.(args);
            },
            onOpenEditorSuccess: (version, toolbarType, contentId) => {
                logger.onOpenEditorSuccess(version, toolbarType, contentId);
                biCallbacks?.onOpenEditorSuccess?.(version, toolbarType, contentId);
            },
            onContentEdited: args => {
                logger.onContentEdited(args);
                biCallbacks?.onContentEdited?.(args);
            },
            onInlineToolbarOpen: args => {
                logger.onInlineToolbarOpen(args);
                biCallbacks?.onInlineToolbarOpen?.(args);
            },
            onToolbarButtonClick: args => {
                logger.onToolbarButtonClick(args);
                biCallbacks?.onToolbarButtonClick?.(args);
            },
            onKeyboardShortcutAction: args => {
                logger.onKeyboardShortcutAction(args);
                biCallbacks?.onKeyboardShortcutAction?.(args);
            },
            onMediaUploadStart: (correlationId, pluginId, fileSize, mediaType, version, contentId) => {
                logger.onMediaUploadStart(correlationId, pluginId, fileSize, mediaType, version, contentId);
                biCallbacks?.onMediaUploadStart?.(correlationId, pluginId, fileSize, mediaType, version, contentId);
            },
            onMediaUploadEnd: (correlationId, pluginId, duration, fileSize, mediaType, isSuccess, errorType, version, contentId) => {
                logger.onMediaUploadEnd(correlationId, pluginId, duration, fileSize, mediaType, isSuccess, errorType, version, contentId);
                biCallbacks?.onMediaUploadEnd?.(correlationId, pluginId, duration, fileSize, mediaType, isSuccess, errorType, version, contentId);
            },
            onPluginAction: (eventName, params) => {
                logger.onPluginAction(eventName, params);
                biCallbacks?.onPluginAction?.(eventName, params);
            },
            onPluginsPopOverTabSwitch: args => {
                logger.onPluginsPopOverTabSwitch(args);
                biCallbacks?.onPluginsPopOverTabSwitch?.(args);
            },
            onPluginsPopOverClick: args => {
                logger.onPluginsPopOverClick(args);
                biCallbacks?.onPluginsPopOverClick?.(args);
            },
            onChangePluginSettings: args => {
                logger.onChangePluginSettings(args);
                biCallbacks?.onChangePluginSettings?.(args);
            },
            mediaPluginsDetails: args => {
                logger.mediaPluginsDetails(args);
                biCallbacks?.mediaPluginsDetails?.(args);
            },
        },
    };
}
//# sourceMappingURL=biStrategy.js.map